import { ConfigProvider } from 'antd';
import { Checkbox as AntdCheckbox } from 'antd';
import { CheckboxProps } from 'antd/lib';
import styled from 'styled-components';
const CleanFeeCheckbox = ({ children, ...props }: CheckboxProps & { children?: React.ReactNode }) => {
  return (
    <ConfigProvider
      theme={{
        components: {
          Checkbox: {
            colorPrimaryHover: '#2D6772',
            colorPrimary: '#2D6772',
            borderRadiusSM: 3,
            controlInteractiveSize: 32,
          },
        },
      }}
    >
      <Container>
        <CheckboxStyled {...props} >
          <span className="checkbox-label-text">{children}</span>
        </CheckboxStyled>
      </Container>
    </ConfigProvider>
  );
};

export default CleanFeeCheckbox;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  flex: 1 0 0;
`;

const CheckboxStyled = styled(AntdCheckbox)`
  display: flex;
  padding: 16px 24px;
  flex-direction: column;
  align-self: stretch;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 8px;
  border: 1px solid #E9EDF2;
  // background: #F2FEFF; // active

  .checkbox-label-text {
    color: #1D2129;
    font-family: Poppins;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 30px; /* 166.667% */
    text-transform: capitalize;
  }
  .ant-checkbox-inner:after {
    top: 49%
  }
  &.ant-checkbox-wrapper {
    flex-direction: column;
  }
  &.ant-checkbox-wrapper:after {
    display: none;
  }
  &.ant-checkbox-wrapper-checked {
  background: #F2FEFF;
    .checkbox-label-text {
      color: #2D6772 !important;
    }
  }
`;